import './App.css';
import {Root} from './components/Root'

function App() {
  return (
    <Root/>
    // <Routes/>
  );
}

export default App;
